class AWProductCarouselProduct {
    constructor(container, data) {
        this.product = data;
        this.currentOptions = [...data.variants[0].options];

        this.container = container;
        this.selects = this.container.querySelectorAll("select");
        this.colorOptionsContainer = this.container.querySelector("[data-option-name='Color']");
        this.imageElement = this.container.querySelector("[data-variant-image]");
        this.priceElement = this.container.querySelector("[data-variant-price]");
        this.addToCartTextElement = this.container.querySelector("[data-add-to-cart-text]");
        this.soundToggleButtons = this.container.querySelectorAll("[data-sound-toggle]");
        this.mediaContainer = this.container.querySelector("[data-product-media]");
        this.secondaryMediaContainer = this.container.querySelector("[data-product-media-secondary]");

        if (this.colorOptionsContainer) {
            this.initializeColorOptions();
        }

        this.selects.forEach((select) => {
            select.addEventListener("change", (e) => {
                const optionIndex = parseInt(e.target.dataset.optionIndex, 10);
                this.currentOptions[optionIndex] = e.target.value;
                const variant = this.product.variants.find(
                    (variant) => variant.options.every((option, index) => option === this.currentOptions[index])
                );

                if (variant) {
                    this.changeCurrentVariant(variant);
                    this.changeOptionsValues(optionIndex);
                }
            });
        });

        this.container.querySelector("[data-add-to-cart]").addEventListener("click", () => {
            this.addToCart();
        });

        this.soundToggleButtons.forEach((button) => {
            button.addEventListener("click", () => {
                button.parentElement.querySelector("video").muted = !button.parentElement.querySelector("video").muted;
                button.querySelectorAll("svg").forEach((icon) => icon.classList.toggle("tw:hidden"));
            });
        });

        if (this.secondaryMediaContainer) {
            const secondaryVideo = this.secondaryMediaContainer.querySelector("video");
            const canHover = window.matchMedia("(hover: hover) and (pointer: fine)").matches;

            if (secondaryVideo && canHover) {
                this.mediaContainer.addEventListener("mouseenter", () => secondaryVideo.play());
                this.mediaContainer.addEventListener("mouseleave", () => secondaryVideo.pause());
            }
        }
    }
    changeCurrentVariant(variant) {
        this.imageElement.src = variant.image;
        this.imageElement.alt = variant.title;

        this.priceElement.textContent = variant.price;
        if (variant.available) {
            this.addToCartTextElement.textContent = "Add to Cart";
        } else {
            this.addToCartTextElement.textContent = "Notify Me";
        }
    }
    changeOptionsValues(optionIndex) {
        const variants = this.product.variants.filter((variant) => 
            this.currentOptions.every((option, index) => variant.options[index] === option || index !== optionIndex)
        );

        this.product.options.forEach((optionName, index) => {
            if (index === optionIndex) return;

            if (optionName.toLowerCase() === "color") {
                const optionTemplate = document.querySelector("[data-color-option-template]");
                const optionsContainer = this.container.querySelector(`[data-option-index="${index}"]`);
                optionsContainer.innerHTML = "";
                optionsContainer.append(
                    ...variants.map((variant) => {
                        const optionElement = optionTemplate.content.cloneNode(true).firstElementChild;
                        optionElement.dataset.colorOption = variant.options[index];
                        optionElement.querySelector("img").src = variant.image;
                        optionElement.querySelector("img").alt = variant.title;
                        return optionElement;
                    })
                );
            } else {
                const select = this.container.querySelector(`select[data-option-index="${index}"]`);
                const currentValue = this.currentOptions[index];
                select.innerHTML = variants.map((variant) => `<option value="${variant.options[index]}" ${variant.options[index] === currentValue ? "selected" : ""}>${variant.options[index]}</option>`)
                    .join("");
            }
        });
    }
    selectColorOption(colorButton) {
        const color = colorButton.dataset.colorOption;
        const optionIndex = parseInt(colorButton.closest("[data-option-index]").dataset.optionIndex, 10);
        this.currentOptions[optionIndex] = color;
        const variant = this.product.variants.find(
            (variant) => variant.options.every((option, index) => option === this.currentOptions[index])
        );
        if (variant) {
            this.colorOptionsContainer.querySelector("[data-color-option].active")?.classList.remove("active");
            colorButton.classList.add("active");
            this.changeCurrentVariant(variant);
            this.changeOptionsValues(optionIndex);
        }
    }
    initializeColorOptions() {
        let isPointerDown = false;
        let didDrag = false;
        let startX = 0;
        let startScrollLeft = 0;
        let pressedButton = null;

        this.colorOptionsContainer.addEventListener("pointerdown", (e) => {
            const button = e.target.closest("[data-color-option]");

            isPointerDown = true;
            didDrag = false;
            pressedButton = button;
            startX = e.clientX;
            startScrollLeft = this.colorOptionsContainer.scrollLeft;

            this.colorOptionsContainer.classList.add("tw:cursor-grabbing");
        });

        this.colorOptionsContainer.addEventListener("pointermove", (e) => {
            if (!isPointerDown) return;

            const dx = e.clientX - startX;

            didDrag = true;

            this.colorOptionsContainer.scrollLeft = startScrollLeft - dx;
        });

        document.addEventListener("pointerup", (e) => {
            const button = e.target.closest("[data-color-option]");

            if (!didDrag && pressedButton && button === pressedButton) {
                this.selectColorOption(button);
            }

            isPointerDown = false;
            didDrag = false;
            pressedButton = null;
            this.colorOptionsContainer.classList.remove("tw:cursor-grabbing");
        });

        this.colorOptionsContainer.addEventListener("pointercancel", () => {
            isPointerDown = false;
            didDrag = false;
            pressedButton = null;
            this.colorOptionsContainer.classList.remove("tw:cursor-grabbing");
        });

        this.colorOptionsContainer.addEventListener("lostpointercapture", () => {
            isPointerDown = false;
            didDrag = false;
            pressedButton = null;
            this.colorOptionsContainer.classList.remove("tw:cursor-grabbing");
        });
    }
    addToCart() {
        const variant = this.product.variants.find(
            (variant) => variant.options.every((option, index) => option === this.currentOptions[index])
        );

        if (!variant) {
            console.error("Variant not found for options:", this.currentOptions);
            return;
        }

        if (!variant.available) {
            location.href = `/products/${this.product.handle}?variant=${variant.id}`;
            return;
        }

        const formData = new FormData();

        formData.append("id", variant.id);
        formData.append("quantity", 1);
        formData.append("sections", "cart-drawer");
        formData.append("sections_url", window.location.pathname);

        fetch(window.FoxThemeSettings.routes.cart_add_url, {
            method: "POST",
            headers: {
                Accept: "application/javascript",
                "X-Requested-With": "XMLHttpRequest",
            },
            body: formData,
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.status) {
                    console.error("Cart error:", data);
                    return;
                }

                window.FoxThemeEvents.emit(PUB_SUB_EVENTS.cartUpdate, data);

                document.dispatchEvent(
                    new CustomEvent("product-ajax:added", {
                        detail: { product: data },
                    })
                );
            })
            .catch((error) => {
                console.error("Error adding to cart:", error);
            });
    }
}

class AWProductCarousel {
    constructor(container) {
        this.isTouchDevice = window.matchMedia("(hover: none) and (pointer: coarse)").matches;
        this.sectionIsVisible = false;

        this.container = container;
        this.swiper = new Swiper(this.container.querySelector(".swiper"), {
            loop: true,
            spaceBetween: 20,
            centeredSlides: true,
            slidesPerView: 1.3,
            noSwipingClass: 'swiper-no-swiping',
            breakpoints: {
                430: {
                    slidesPerView: 2
                },
                1024: {
                    slidesPerView: 3.3

                },
                1440: {
                    slidesPerView: 5.3
                }
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            }
        });

        this.swiper.on("slideChange", () => {
            this.updateVideos();
        });

        const products = container.querySelectorAll("[data-product-id]");
        const productsData = JSON.parse(this.container.querySelector("[data-products-json]").textContent);

        products.forEach((product) => {
            const productId = product.dataset.productId;
            const productData = productsData.find(p => p.id === parseInt(productId));
            new AWProductCarouselProduct(product, productData);
        });

        if (this.isTouchDevice) {
            this.initVideoObserver();
        }
    }

    initVideoObserver() {
        const observer = new IntersectionObserver(
            ([entry]) => {
                this.sectionIsVisible = entry.isIntersecting && entry.intersectionRatio >= 0.3;
                this.updateVideos();
            },
            { threshold: [0, 0.3] }
        );

        observer.observe(this.container);
    }

    updateVideos() {
        if (!this.isTouchDevice) return;

        const activeSlide = this.swiper.slides[this.swiper.activeIndex];

        this.container.querySelectorAll("[data-product-media-secondary]").forEach((element) => {
            const video = element.querySelector("video");
            if (!video) return;

            const slide = video.closest(".swiper-slide");

            const shouldPlay =
                this.sectionIsVisible &&
                slide === activeSlide;

            if (shouldPlay) {
                video.play().catch(() => {});
                element.style.opacity = "1";
                element.style.visibility = "visible";
            } else {
                element.style.opacity = "0";
                element.style.visibility = "hidden";
                video.pause();
            }
        });
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const carousels = document.querySelectorAll(".aw-product-carousel");
    carousels.forEach((carousel) => new AWProductCarousel(carousel));
});